import { Component, Input, OnInit } from '@angular/core';
import { ActionService, PigeonholeInventoryAction } from 'src/app/core/services/action.service';
import { TaskRequestSidenavService } from 'src/app/core/services/task-request-sidenav.service';
import { ErrorService } from 'src/app/core/services/error.service';
import { SendTasksTypeEnum } from 'src/app/core/data-sources/action-data-source.service';
import { PigeonholePositionInfo } from 'src/models/Pigeonhole';
import { toExcelFormat } from 'src/app/helpers/format-position';

@Component({
  selector: 'app-pigeonhole-inventory-sidenav',
  templateUrl: './pigeonhole-inventory-sidenav.component.html',
  styleUrls: ['./pigeonhole-inventory-sidenav.component.scss']
})
export class PigeonholeInventorySidenavComponent implements OnInit {
  @Input() drawer;
  @Input() data: PigeonholePositionInfo;
  usersHighlighted = [];
  selectOperatorError = false;

  constructor(
    private sidenavService: TaskRequestSidenavService,
    private actionService: ActionService,
    private errorService: ErrorService,
  ) { }

  ngOnInit(): void {
  }

  get positionLabel(): string {
    if (!this.data) return '';
    return this.data.alias || toExcelFormat(this.data.x, this.data.y);
  }

  setUsers(users) {
    this.usersHighlighted = users;
  }

  setOperatorLengthError() {
    this.selectOperatorError = !this.usersHighlighted.length;
  }

  async submit() {
    try {
      this.setOperatorLengthError();
      if (this.usersHighlighted.length) {
        const params: PigeonholeInventoryAction = {
          type: SendTasksTypeEnum.INVENTORY_BY_PIGEONHOLE_POSITION,
          userIds: this.usersHighlighted,
          taskData: {
            positions: [{ x: this.data.x, y: this.data.y, z: this.data.z }],
            deepSearch: false,
            excludeStates: [],
          },
        };
        await this.actionService.inventoryByPigeonholePosition(params);
      }
      this.drawer.close();
      this.sidenavService.closeSidenav(true);
      this.usersHighlighted = [];
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    }
  }

  close() {
    try {
      this.drawer.close();
      this.sidenavService.closeSidenav(false);
    } finally {
      this.usersHighlighted = [];
    }
  }
}
